import { Component, Inject, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgxToastrService } from '../_services/ngx-toastr/ngx-toastr.service';
import { LoadingService } from '../services/loading.service';
import { NgClass, NgIf } from '@angular/common';
import { HttpServiceService } from '../services/http-service.service';
import { Subscription } from 'rxjs';
import { NgxIntlTelInputModule, SearchCountryField } from 'ngx-intl-tel-input';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-register',
  imports: [ReactiveFormsModule, RouterModule, NgIf, NgClass, NgxIntlTelInputModule, NgbModule],
  templateUrl: './register.component.html',
  styleUrl: './register.component.css'
})
export class RegisterComponent {
  hide_show: boolean = false;
  confirm_hide_show : boolean = false;
  registerForm: FormGroup;
  logo : string | null = '';
  loadingService = inject(LoadingService);
  private httpService = inject(HttpServiceService); 
  userRegistrerSubscription : Subscription | undefined;
  SearchCountryField = SearchCountryField;
  alert : any;
  isRegistrationSuccess :  boolean = false;

  constructor(private fb: FormBuilder, private router : Router, private alertService: NgxToastrService, private sanitizer: DomSanitizer){
    this.registerForm = this.fb.group({
      first_name : ['', [Validators.required]],
      last_name : ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      password : ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$(!%*?&)_-])[A-Za-z\d@$!(%*?&)-_]{6,}$/)]],
      confirmPassword : ['', [Validators.required]],
      phone: ['', [Validators.required]],
      role_identifier : ['', [Validators.required]]
    }, { validators: this.passwordMatchValidator } );
    this.alert = {
      type: 'success',
      typeMsg: 'A verification email has been sent to your registered email address. Please check your inbox and follow the instructions to validate your email.',
      icon: this.sanitizer.bypassSecurityTrustHtml('<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="me-2"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>'),
      message: '',
    }
  }

  ngOnInit(){
    this.logo = this.httpService.getLogoUrl() ?? "";
  }

  passwordHide(){
    this.hide_show = !this.hide_show;
  }

  confirmPasswordHide(){
    this.confirm_hide_show = !this.confirm_hide_show;
  }

  passwordMatchValidator(control: AbstractControl) {
    const password = control.get('password')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;    
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  onSubmit(){
    if (this.registerForm.valid) {
      this.isRegistrationSuccess = false;
      let phone = this.registerForm.get("phone")?.value;
      let obj = {
        ...this.registerForm.value,
        dial_code : phone.dialCode,
        phone : phone.number?.replace(/[-\s]/g, "")
      }
      delete obj.confirmPassword;
      this.userRegistrerSubscription = this.httpService.vendorOwnerRegistration(obj).subscribe({
        next : (response) => {
          this.isRegistrationSuccess = true;
          this.registerForm.reset();
          this.alertService.success(response.message, "toast-top-right");
        },
        error : (error) => {          
        }
      })
    }
  }

  get password() { return this.registerForm!.get('password'); }
  get confirmPassword() { return this.registerForm!.get('confirmPassword'); }

  ngOnDestroy(){
    this.userRegistrerSubscription?.unsubscribe();
  }

}
